// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___K57Q","rotator":"styles_rotator__m9xUB","center-rotator":"styles_center-rotator__yi0WV","shimmer":"styles_shimmer__8H0yE"};